<template>

  <BasicLayout>
    <div class="header" slot="header">
      <div>Edit a Competition</div>
      <DeleteButton class="del-bt" @click="del"></DeleteButton>
    </div>
    <div class="container" v-if="competition">
      <div class="label">Name</div>
      <input v-model="competition.name"/>
      <div class="label">Sport</div>
      <SportSelector v-model="competition.sportID"></SportSelector>
      <div class="label">Region</div>
      <RegionSelector v-model="competition.regionID"></RegionSelector>
    </div>
    <div class="buttons"><Button class="cancel-bt" @click="cancel">Cancel</Button><Button class="save-bt" @click="save">Save</Button></div>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import SportSelector from '@/components/SportSelector'
import RegionSelector from '@/components/RegionSelector'
import Button from '@/components/common/Button'
import DeleteButton from '@/components/common/DeleteButton'

export default {
  name: 'EditCompetition',
  components: {
    BasicLayout,
    SportSelector,
    RegionSelector,
    Button,
    DeleteButton
  },
  data () {
    return {
      id: this.$route.params.id,
      competition: null
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    save () {
      this.$store.dispatch('patchCompetition', this.competition)
        .then(resp => {
          this.$router.go(-1)
        })
        .catch(console.error)
    },
    del () {
      this.$store.dispatch('deleteCompetition', this.id)
        .then(() => {
          this.$router.go(-1)
        })
        .catch(console.error)
    }
  },
  mounted () {
    this.competition = this.$store.state.competitions[this.id]
    if (this.competition) {
      this.competition = JSON.parse(JSON.stringify(this.competition)) // deep clone
    }

    if (!this.competition) {
      this.$store.dispatch('getCompetition', this.id)
        .then(competition => {
          this.competition = competition.data
        })
        .catch(err => {
          console.log(err)
          this.$router.push('/not-found')
        })
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors.scss';

.container {
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-auto-columns: 60px;
  grid-auto-flow: row;
  grid-row-gap: 15px;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
}

.del-bt {
  height: 40px;
}

.buttons {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 100px 100px;
  grid-template-areas: "cancel save";
  grid-column-gap: 15px;
  float: right;
}

.cancel-bt {
  background-color: $detail-color;
  grid-area: cancel;
}

.save-bt {
  background-color: $secondary-color;
  grid-area: save;
}

</style>



// WEBPACK FOOTER //
// src/pages/EditCompetition.vue